import z from 'zod';
import { UUIDSchema, UnixTimestampSchema } from '../common/schemas';
import { DBJsonObjectSchema, DBTimestampSchema, JsonObjectSchema } from '../common/sql';

/**
 * DB Schemas
 *
 * The log is append-only: a row is written once, by the transaction that did
 * what it records, and never updated.
 */

export const DBAuditEventActionSchema = z.string().min(1).max(128);
export const DBAuditEventEntityTypeSchema = z.string().min(1).max(64);

export const DBAuditEventSchema = z.object({
  id: UUIDSchema,
  actorId: UUIDSchema.nullable(),
  action: DBAuditEventActionSchema,
  entityType: DBAuditEventEntityTypeSchema,
  entityId: UUIDSchema.nullable(),
  payload: DBJsonObjectSchema,
  createdAt: DBTimestampSchema,
});

/**
 * Client Schemas
 */

export const AuditEventIdSchema = UUIDSchema;

export const AuditEventActionSchema = DBAuditEventActionSchema.openapi({
  description: 'What happened, as entity.verb',
  example: 'question_set.published',
});

export const AuditEventEntityTypeSchema = DBAuditEventEntityTypeSchema.openapi({
  description: 'The kind of row the event is about',
  example: 'question_set',
});

export const AuditEventSchema = z.object({
  id: AuditEventIdSchema,
  actorId: UUIDSchema.nullable().openapi({
    description: 'The app user who did it; null for a pipeline',
  }),
  action: AuditEventActionSchema,
  entityType: AuditEventEntityTypeSchema,
  entityId: UUIDSchema.nullable(),
  payload: JsonObjectSchema,
  createdAt: UnixTimestampSchema,
});
